<template>
  <a-select
    showSearch
    placeholder="标注状态"
    optionFilterProp="children"
    style="width: 100%"
    v-model="value"
    @change="handleChange"
    :filterOption="filterOption"
  >
    <a-select-option key="未标注">未标注</a-select-option>
    <a-select-option key="已标注">已标注</a-select-option>
    <a-select-option key="重新标注">重新标注</a-select-option>
    <a-select-option key="已确认">已确认</a-select-option>
  </a-select>
</template>

<script>
import { getHospitalList } from '@/api/hospital'

export default {
  name: 'SelectLabelStatus',
  data () {
    return {
      values: [],
      value: ''
    }
  },

  methods: {
    handleChange (value) {
      this.value = value
      this.$emit('search_condition_changed')
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
